import clsx from "clsx";

import { Constants } from "appConstants";
import "./styles.scss";
import { StatusTagProps } from "./types";

export default function StatusTag({ children }: StatusTagProps) {
	return (
		<div
			className={clsx(`tag-component`, {
				"tag-active":
					children === Constants.strings.pages.listing.term.statusType.active,
				"tag-inactive":
					children === Constants.strings.pages.listing.term.statusType.inactive,
				"tag-scheduled":
					children === Constants.strings.pages.listing.term.statusType.scheduled
			})}
		>
			<div className="tag-children">{children}</div>
		</div>
	);
}
